"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ThumbsUpSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10.5,3 C11.2796961,3 11.9204487,3.59488808 11.9931334,4.35553999 L12,4.5 L11.999,7 L14.4952291,7 C15.2261942,7 15.835041,7.52285085 15.9681819,8.21496507 L15.9883625,8.35553999 L15.9952291,8.5 L15.9890887,8.63558586 L15.9707178,8.77006165 L15.0555577,13.7700616 C14.9338535,14.4349959 14.384931,14.9301325 13.7234282,14.9931955 L13.5800691,15 L7,15 C7,15.5522847 6.55228475,16 6,16 L4,16 C3.44771525,16 3,15.5522847 3,15 L3,9 C3,8.44771525 3.44771525,8 4,8 L6,8 C6.35105098,8 6.65985268,8.18089067 6.83827992,8.45454682 L8.088,7.204 L10.190983,3 L10.5,3 Z M6,9 L4,9 L4,15 L6,15 L6,9 Z M10.769,4.08 L8.9472136,7.7236068 L7,9.705 L7,14 L13.5800691,14 C13.7611353,14 13.9228068,13.9029671 14.010663,13.7542653 L14.0481879,13.6758186 L14.0718986,13.5900205 L14.9870587,8.59002055 C14.9924945,8.56032193 14.9952291,8.53019199 14.9952291,8.5 C14.9952291,8.25454011 14.818354,8.05039163 14.5851048,8.00805567 L14.4952291,8 L11,8 L11,4.5 C11,4.37727006 10.9557812,4.26486796 10.8824063,4.17785636 L10.8221436,4.11759373 L10.769,4.08 Z" })));
};
ThumbsUpSmall.displayName = 'ThumbsUpSmall';
exports.default = ThumbsUpSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ThumbsUpSmall.js.map